
/**
 * 추가 메타데이터
 */
export type StreamingInfoResponseMediaInfoMetadata = { [key: string]: unknown };
